import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { FormField, Link, SegmentedControl, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAirplane, mdiClipboardArrowDownOutline, mdiHelicopter } from '@mdi/js';
import Icon from '@mdi/react';
import { addMonths, format } from 'date-fns';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import ConfirmDelete from '../../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';

export const OPSFuelPrices = () => {
    const { idUser, data, menu, parameters, version, loading, notifications, displayName, RUT } = useGlobalState();
    useGlobalState();
    const { navigate } = useRouter();
    const [documents, setDocuments] = React.useState<any[]>([]);
    const [document, setDocument] = React.useState<any>();
    const [prices, setPrices] = React.useState<any>();
    const [type, setType] = React.useState("");
    const [airport, setAirport] = React.useState("");


    const handleUpdatePrices = async () => {
        //if (parameters.startDate && parameters.endDate) {

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/parameters/indicators/update.number',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(
                    {
                        parameter: `${document.type}.INT`,
                        value: document.internal
                    }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code === 0) {

            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { handleUpdatePrices2(); }
    }


    const handleUpdatePrices2 = async () => {
        //if (parameters.startDate && parameters.endDate) {

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/parameters/indicators/update.number',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(
                    {
                        parameter: `${document.type}.EXT`,
                        value: document.external
                    }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code === 0) {
                setDocument(undefined);
                handleGetInvoices();
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleGetInvoices = async () => {
        //if (parameters.startDate && parameters.endDate) {

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/dte/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    RUTIssuer: '99520000-7',
                    RUTReceiver: '65289080-6',
                    DTEType: 33,
                    orderBy: 'DTEDate',
                    order: 'desc',
                    start: format(addMonths(new Date(), -12), 'dd-MM-yyyy'),
                    end: format(new Date(), 'dd-MM-yyyy'),
                }),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code === 0 && dataWeb.dte) {
                const data = dataWeb.dte;
                const docs = (data.map((doc: any) => ({
                    ...doc,
                    price: Math.round(doc?.json?.Detalle?.[0]?.PrcItem),
                    internal: Math.round(doc?.json?.Detalle?.[0]?.PrcItem * 1.19 * 1.15),
                    external: Math.round(doc?.json?.Detalle?.[0]?.PrcItem * 1.19 * 1.40),
                    type: doc?.json?.Detalle?.[0]?.NmbItem.toLowerCase().includes("100ll") ? "AVGAS" : doc?.json?.Detalle?.[0]?.NmbItem.toLowerCase().includes("kerose") ? "JP1" : "",
                    airport: doc?.json?.Encabezado?.Transporte?.CmnaDest.toLowerCase().includes("vitacura") ? "SCLC" : doc?.json?.Encabezado?.Transporte?.CmnaDest.toLowerCase().includes("colina") ? "SCHC" : "",
                    detalle: doc?.json?.Detalle?.[0]
                })));
                setDocuments(docs);
                setPrices(dataWeb.prices);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }

    useEffect(() => {
        handleGetInvoices();

    }, []);

    const filtered = documents.filter((doc: any) => {
        const matchesType = !type || doc.type === type;
        const matchesAirport = !airport || doc.airport === airport;

        return matchesType && matchesAirport;
    });

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }

            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}
                        description={`Listado de precios de combustibles, desde facturas hasat 12 meses de antiguedad`}
                    >Precios combustibles</Header>
                    <SpaceBetween direction="horizontal" size="xs">
                        <FormField label="AVGAS" description={`Precio actual`}
                            constraintText={`Ext: ${formatCurrency(prices?.AVGASEXT ?? 0, "CLP")}`}>
                            Int: {formatCurrency(prices?.AVGASINT ?? 0, "CLP")}
                        </FormField>

                        <FormField label="JP1" description={`Precio actual`}
                            constraintText={`Ext: ${formatCurrency(prices?.JP1EXT ?? 0, "CLP")}`}
                        >
                            Int: {formatCurrency(prices?.JP1INT ?? 0, "CLP")}
                        </FormField>
                    </SpaceBetween>

                    <Table
                        filter={
                            <SpaceBetween direction="horizontal" size="xs">
                                <SegmentedControl selectedId={type} options={[
                                    { id: '', text: 'Todos' },
                                    { id: 'AVGAS', text: 'AVGAS' },
                                    { id: 'JP1', text: 'JP1' },
                                ]} onChange={({ detail }) => {
                                    setType(detail.selectedId);

                                }} />
                                <SegmentedControl selectedId={airport} options={[
                                    { id: '', text: 'Todos' },
                                    { id: 'SCLC', text: 'SCLC' },
                                    { id: 'SCHC', text: 'SCHC' },
                                ]} onChange={({ detail }) => {
                                    setAirport(detail.selectedId);

                                }} />

                            </SpaceBetween>

                        }
                        variant="embedded"
                        stickyHeader={true}
                        items={filtered || []}
                        columnDefinitions={[
                            {
                                id: 'date',
                                header: 'Fecha',
                                cell: (item) => item.DTEDate,
                                width: 50,
                            },
                            {
                                id: 'number',
                                header: 'Folio',
                                cell: (item) => item.number,
                                width: 50,
                            },
                            {
                                id: 'apt',
                                header: 'Destino',
                                cell: (item) => item?.json?.Encabezado?.Transporte?.CmnaDest === "VITACURA" ? <BadgeCustom color={'blue'}>SCLC</BadgeCustom> : item?.json?.Encabezado?.Transporte?.CmnaDest === "COLINA" ? <BadgeCustom color={'lime'}>SCHC</BadgeCustom> : item?.json?.Encabezado?.Transporte?.CmnaDest,
                                width: 50,
                            },
                            {
                                id: 'type',
                                header: 'Tipo',
                                cell: (item) => item?.json?.Detalle[0]?.NmbItem.toLowerCase().includes("100ll") ? <Icon path={mdiAirplane} size={1} /> : item?.json?.Detalle[0]?.NmbItem.toLowerCase().includes("kerose") ? <Icon path={mdiHelicopter} size={1} /> : item?.json?.Detalle[0]?.NmbItem,
                                width: 50,
                            },
                            {
                                id: 'price',
                                header: 'Precio',
                                cell: (item) => formatCurrency(Math.round(item?.json?.Detalle[0]?.PrcItem), "CLP"),
                                width: 50,
                            },
                            {
                                id: 'sell',
                                header: 'Venta',
                                cell: (item) => <FormField label={`Socio: ${formatCurrency(Math.round(item?.json?.Detalle[0]?.PrcItem * 1.19 * 1.15), "CLP")}`}>
                                    {`Externo: ${formatCurrency(Math.round(item?.json?.Detalle[0]?.PrcItem * 1.19 * 1.4), "CLP")}`}
                                </FormField>,
                            },
                            {
                                id: 'assign',
                                header: 'Asignar',
                                cell: (item) => item.airport == "SCLC" ? <Link variant="primary" onClick={() => {
                                    setDocument(item);
                                }}><Icon path={mdiClipboardArrowDownOutline} size={1} /></Link> : "",
                                width: 50,
                            },
                        ]}

                    />
                    {!!document && (
                        <ConfirmDelete
                            subtitle={<>¿Está seguro de asignar el precio de venta de combustible para el tipo <b>{document?.type}</b>?. Los nuevos valores serán fijados para socios en <b>{formatCurrency(document?.internal, "CLP")}</b> y para externos en <b>{formatCurrency(document?.external, "CLP")}</b>.</>}
                            button={"info"}

                            show={!!document} confirmWord={'asignar'} action={'Asignar'} warning={'Se modificaran los valores de venta de combustible'} header='Confirmar actualización'
                            onDismiss={() => setDocument(undefined)} onConfirm={() => {
                                handleUpdatePrices();
                            }}
                        />
                    )}

                </SpaceBetween>
            }
        />
    )
};
